import { InputTextField } from '@abbott-components/core';
import { JSONSchema7 } from 'json-schema';
import { useContext } from 'react';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import { WorkflowEngineContext } from '../../WorkflowEngine/workflowEngineReducer';

export default (control: ControlState) => {
  const { state } = useContext(WorkflowEngineContext);

  const { isReadOnlyView } = state;

  const properties = control.schema?.properties as JSONSchema7Properties;
  const labelSchema = properties['label'] as JSONSchema7;
  const iisMultiLine = (properties['isMultiLine'] as JSONSchema7)
    ?.default as boolean;
  return (
    <InputTextField
      label={labelSchema?.default as string}
      name={control.id}
      isDisabled={isReadOnlyView}
      multiline={iisMultiLine}
      minRows={iisMultiLine ? 2 : 1}
    />
  );
};
